import '../../Styles/Sass/LookingCleaner.scss';

function LookingCleaner() {
  return (
    <section className='lookingCleaner'>
    	<h2 className='lookingCleaner__title'>Looking for a Job as a Cleaner?</h2>
    	<h3 className='lookingCleaner__subtitle'>Sign up today to start exploring new opportunities!</h3>
    	<button className='greenButton lookingCleaner__button'>Get Started</button>
    </section>
  );
}

export default LookingCleaner;